<template>
  <span class="svg-icon-grid-view">
    <svg v-if="isTwoTone" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.1859 10.7209H15.0959V3.52087C15.0959 1.84087 14.1859 1.50087 13.0759 2.76087L12.2759 3.67087L5.50589 11.3709C4.57589 12.4209 4.96589 13.2809 6.36589 13.2809H9.45589V20.4809C9.45589 22.1609 10.3659 22.5009 11.4759 21.2409L12.2759 20.3309L19.0459 12.6309C19.9759 11.5809 19.5859 10.7209 18.1859 10.7209Z" :fill="color" :stroke="color" stroke-width="1.5"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.0954 7.02087V3.52087C15.0954 1.84087 14.1854 1.50087 13.0754 2.76087L5.50539 11.3609C4.57539 12.4109 4.96539 13.2809 6.37539 13.2809H9.46539V20.4809C9.46539 22.1609 10.3754 22.5009 11.4854 21.2409L19.0554 12.6409C19.9854 11.5909 19.5954 10.7209 18.1854 10.7209H15.0954" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 28 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>